var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "kanban-column-header",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("span", {
        staticClass: "column-dot",
        style: { backgroundColor: _vm.column.hexColor }
      }),
      _c("strong", [_vm._v(_vm._s(_vm.column.label))]),
      _c("span", { staticClass: "column-count" }, [_vm._v(_vm._s(_vm.count))]),
      _vm.allowAddDeliverable
        ? _c(
            "button",
            {
              attrs: {
                type: "button",
                "aria-label": _vm.$t("projects.add-deliverable")
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.addDeliverable(_vm.column)
                }
              }
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("+")])]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }